import { Card } from "@heroui/react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import type { PeriodStatPoint } from "../model/types";
import { CustomTooltip } from "./CustomTooltip";

export interface StatisticsConversionsChartProps {
  data: PeriodStatPoint[];
}

export const StatisticsConversionsChart = ({
  data,
}: StatisticsConversionsChartProps) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-xs text-neutral-400">Конверсии (CPA)</div>
      <Card className="p-4">
        <div className="h-60 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={data}
              margin={{ top: 8, right: 10, left: -15, bottom: 0 }}
            >
              <defs>
                <linearGradient
                  id="conversionsGradient"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="rgba(255,255,255,0.06)"
                vertical={false}
              />
              <XAxis
                dataKey="date"
                stroke="#737373"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="#737373"
                fontSize={11}
                tickLine={false}
                axisLine={false}
                allowDecimals={false}
              />
              <Tooltip
                content={<CustomTooltip />}
                cursor={{
                  stroke: "rgba(255, 255, 255, 0.2)",
                  strokeWidth: 1,
                  strokeDasharray: "2 2",
                }}
              />
              <Area
                type="monotone"
                dataKey="conversions"
                name="Конверсии"
                stroke="#10b981"
                strokeWidth={2}
                fill="url(#conversionsGradient)"
                activeDot={{
                  r: 4,
                  fill: "#10b981",
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

